class BreakpointHelper {
    /**
     * @param breakpoint
     * @param aboveBreakpoint
     * @returns {{aboveBreakpoint: boolean, breakpointCrossed: boolean}}
     */
    static breakpointCrossed(breakpoint, aboveBreakpoint = false) {
        let breakpointCrossed = false;

        if (window.matchMedia(`(min-width: ${breakpoint})`).matches) {
            if (!aboveBreakpoint) {
                aboveBreakpoint = true;
                breakpointCrossed = true;
            }
            return { aboveBreakpoint, breakpointCrossed };
        }

        if (aboveBreakpoint) {
            aboveBreakpoint = false;
            breakpointCrossed = true;
        }

        return { aboveBreakpoint, breakpointCrossed };
    }

    /**
     * @param breakpoint
     * @returns {boolean}
     */
    static aboveBreakpoint(breakpoint) {
        let query = `(min-width: ${breakpoint})`;
        if (!BreakpointHelper.hasUnit(breakpoint)) {
            query = `(min-width: ${breakpoint}px)`;
        }
        return window.matchMedia(query).matches;
    }

    static hasUnit(value) {
        const unitRegex = /(px|em|rem|%|vh|vw|vmin|vmax|cm|mm|in|pt|pc|ex|ch)$/i;

        return typeof value === 'string' && unitRegex.test(value);
    }
}

export default BreakpointHelper;
